module.exports = __webpack_public_path__ + "img/step10-b.22c638ea.png";